import { toast } from '@askable/ui/core/sonner';
import { deprecatedWithRouter } from 'HOC/deprecatedWithRouter';
import { useEffect } from 'react';
import { useMutation } from 'urql';

import { LoadingOverlay } from 'components/common';
import { useConnectedClient } from 'context/ConnectedClientContext';
import { getCombinedErrorMessage } from 'utils/error_utils';
import { isImpersonating } from 'utils/impersonation';

import { JoinNufp } from './data/JoinNufp.mutation';

function JoinNUFP(props: any) {
  const { details: clientDetails } = useConnectedClient();
  const [{ fetching: loading }, joinNUFP] = useMutation(JoinNufp);

  useEffect(() => {
    const executeAction = async () => {
      const teamId = clientDetails?.team?.id!;
      if (teamId && !isImpersonating()) {
        const { error } = await joinNUFP({
          _id: teamId,
        });
        if (error) {
          toast.error(getCombinedErrorMessage(error, 'Error joining NUFP'));
        }
        props.history.replace({ pathname: '/' });
      }
    };
    void executeAction();
  }, []);

  if (loading) return <LoadingOverlay />;
  return null;
}

export default deprecatedWithRouter(JoinNUFP);
